var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading"},[_c('h1',[_vm._v(_vm._s(_vm.head))]),_c('h3',[_vm._v(_vm._s(_vm.subHead))]),_c('p',[_vm._v(_vm._s(_vm.subText))])])}
var staticRenderFns = []

export { render, staticRenderFns }